'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function (theme) {
    var primary = (0, _color2.default)(theme.elAccent),
        hoverColor = void 0;

    hoverColor = primary.rotate(2);
    hoverColor = (0, _color2.default)(hoverColor).saturate(0.3);
    hoverColor = (0, _color2.default)(hoverColor).darken(0.2);
    hoverColor = hoverColor.rgb().string();

    return {
        animationBackgroundColor: primary.lighten(0.2).rgb().string(),
        color: theme.tInversion,
        borderColor: theme.elAccent,
        background: theme.elAccent,

        focusColor: theme.tInversion,
        focusBorderColor: theme.elAccent,
        focusBackground: theme.elAccent,

        hoverColor: theme.tInversion,
        hoverBorderColor: hoverColor,
        hoverBackground: hoverColor,

        activeColor: theme.tInversion,
        activeBorderColor: theme.elAccent,
        activeBackground: theme.elAccent,

        disabledColor: theme.tDisabled,
        disabledBorderColor: theme.elDivider,
        disabledBackground: theme.elDivider
    };
};

var _color = require('color');

var _color2 = _interopRequireDefault(_color);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }